import { render, staticRenderFns } from "./ProduitDetail.vue?vue&type=template&id=6c8a1c62&"
import script from "./ProduitDetail.vue?vue&type=script&lang=js&"
export * from "./ProduitDetail.vue?vue&type=script&lang=js&"
import style0 from "./ProduitDetail.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports